import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthsContainer", "monthTemplate", "weekdaysContainer", "weekdayTemplate",
                     "erasContainer", "eraTemplate", "monthsField", "weekdaysField", "erasField"]

  addMonth() {
    if (this.hasMonthTemplateTarget) {
      const clone = this.monthTemplateTarget.content.cloneNode(true)
      const position = this.monthsContainerTarget.querySelectorAll("[data-month-row]").length + 1
      const posInput = clone.querySelector("[data-position]")
      if (posInput) posInput.value = position
      this.monthsContainerTarget.appendChild(clone)
    }
  }

  removeMonth(event) {
    event.target.closest("[data-month-row]").remove()
    this.reindexMonths()
  }

  addWeekday() {
    if (this.hasWeekdayTemplateTarget) {
      const clone = this.weekdayTemplateTarget.content.cloneNode(true)
      this.weekdaysContainerTarget.appendChild(clone)
    }
  }

  removeWeekday(event) {
    event.target.closest("[data-weekday-row]").remove()
  }

  addEra() {
    if (this.hasEraTemplateTarget) {
      const clone = this.eraTemplateTarget.content.cloneNode(true)
      this.erasContainerTarget.appendChild(clone)
    }
  }

  removeEra(event) {
    event.target.closest("[data-era-row]").remove()
  }

  serialise(event) {
    // Gather months
    const months = []
    this.monthsContainerTarget.querySelectorAll("[data-month-row]").forEach((row, i) => {
      const name = row.querySelector("[data-month-name]")?.value?.trim()
      const days = parseInt(row.querySelector("[data-month-days]")?.value, 10)
      if (name && days > 0) {
        months.push({ name, days, position: i + 1 })
      }
    })

    // Gather weekdays
    const weekdays = []
    this.weekdaysContainerTarget.querySelectorAll("[data-weekday-row]").forEach(row => {
      const name = row.querySelector("[data-weekday-name]")?.value?.trim()
      if (name) weekdays.push(name)
    })

    // Gather eras
    const eras = []
    this.erasContainerTarget.querySelectorAll("[data-era-row]").forEach(row => {
      const name = row.querySelector("[data-era-name]")?.value?.trim()
      const startYear = parseInt(row.querySelector("[data-era-start]")?.value, 10)
      const endYear = row.querySelector("[data-era-end]")?.value?.trim()
      if (name && startYear) {
        const era = { name, start_year: startYear }
        if (endYear) era.end_year = parseInt(endYear, 10)
        eras.push(era)
      }
    })

    if (this.hasMonthsFieldTarget) this.monthsFieldTarget.value = JSON.stringify(months)
    if (this.hasWeekdaysFieldTarget) this.weekdaysFieldTarget.value = JSON.stringify(weekdays)
    if (this.hasErasFieldTarget) this.erasFieldTarget.value = JSON.stringify(eras)
  }

  reindexMonths() {
    this.monthsContainerTarget.querySelectorAll("[data-month-row]").forEach((row, i) => {
      const posInput = row.querySelector("[data-position]")
      if (posInput) posInput.value = i + 1
    })
  }
}
